import { Box, Paper } from '@mantine/core'
import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'

import { GlobalLoadingOverlay } from '@/components/GlobalLoadingOverlay'
import { VersionButton } from '@/components/VersionButton'
import * as classes from '@/styles/AuthLayout.css'

type AuthLayoutProps = PropsWithChildren

export const AuthLayout = observer(function AuthLayout(props: AuthLayoutProps) {
  return (
    <Box component="main" className={classes.wrapper}>
      <Paper className={classes.slot} radius={0}>
        {props.children}

        <VersionButton className={classes.versionButton} />
        <GlobalLoadingOverlay />
      </Paper>
    </Box>
  )
})
